const initialState = {
  name: '',
  realName: '',
  phone: '',
  email: '',
  userImgId: '',
  userImgUrl: '',
}

export default function chatUserReducer(state = initialState, action) {
  switch (action.type) {
    case 'CHAT_USER_SET_IMG': {
      state.userImgId = action.payload.userImgId || ''
      state.userImgUrl = action.payload.userImgUrl || ''
      return { ...state }
    }
    case 'CHAT_USER_SET_NAME': {
      state.name = action.payload
      return { ...state }
    }

    case 'CHAT_USER_SET_USERDATA': {
      state.realName = action.payload.formName
      state.phone = action.payload.formNumber
      state.email = action.payload.formEmail
      return { ...state }
    }

    case 'CHAT_USER_SET_FORCE_RECONNECT': {
      state.name = action.payload.name
      state.realName = action.payload.formName
      state.phone = action.payload.formNumber
      state.email = action.payload.formEmail
      state.userImgId = action.payload.userImgId
      state.userImgUrl = action.payload.userImgUrl
      return { ...state }
    }

    default: {
      return state
    }
  }
}
